<div class="ui-messages">
  <p class="ion-text-center">
    <!-- TODO translate this, stats module -->
    Próximamente podrás consultar información y estadísticas de tus operaciones con OkCargo (viajes realizados,...).
  </p>
</div>
